import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { NumberInput } from 'ui-components/components/number-input';

import { FilterItem } from './filter-item';
import messages from './messages';
import drawerMessages from '../../../messages';

/**
 * SalesTrendModifierFilter component that provides a number input for sales trend modifier
 * @param {object} props - Component props
 * @param {number} props.value - Current value
 * @param {(value: number) => void} props.onChange - Callback function when value changes
 * @returns {React.ReactElement} The rendered SalesTrendModifierFilter component
 */
export const SalesTrendModifierFilter = ({ value, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <FilterItem
      ariaLabel={formatMessage(messages.salesTrendModifierAriaLabel)}
      inputComponent={<NumberInput max={1000} min={-1000} onChange={onChange} value={value} />}
      label={<FormattedMessage {...drawerMessages.salesTrendModifierLabel} />}
    />
  );
};
